<div class="ui padded grid">
  <div class="row">
    <div class="two wide column">
      <!--SIDEBAR-->
      <div class="ui vertical fluid tabular menu">
        <a class="item" routerLink="profile" [routerLinkActive]="['active']" i18n="@@profile">
          Profil
        </a>
        <a class="item" routerLink="newsletter" [routerLinkActive]="['active']" i18n="@@newsletter">
          Newsletter
        </a>
      </div>
    </div>
    <div class="fourteen wide stretched column">
      <div class="ui segment">
        <!--CONTENT-->
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

